<template>
  <div class="mainbody">
    <div id="app" v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>统计报表</el-breadcrumb-item>
          <el-breadcrumb-item>会员统计</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="toolbar-box">
        <div class="list-box">
          <div class="r-list">
            <div class="search-box">
              <el-date-picker
                style="width: auto"
                v-model="dateRange"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              >
              </el-date-picker>
            </div>
            <div class="btn-box">
              <el-button
                type="primary"
                plain
                icon="el-icon-search"
                @click="initData"
                >查询</el-button
              >
            </div>
          </div>
        </div>
      </div>

      <div class="content-box">
        <el-card
          shadow="never"
          v-loading="loading"
          style="
            position: absolute;
            top: 124px;
            bottom: 20px;
            left: 20px;
            right: 20px;
          "
        >
          <div
            id="reportChart"
            style="
              position: absolute;
              top: 20px;
              bottom: 20px;
              left: 20px;
              right: 20px;
            "
          ></div>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts"; //eslint-disable-line no-unused-vars
import { AxiosAjax } from "../../js/axios.config";

export default {
  data() {
    return {
      loading: false,
      dateRange: [],
      echartData: [],
      echartList: [],
    };
  },
  mounted() {
    if (window.localStorage.getItem("fx_login_companyType") == "1") {
      _this.companyId = window.localStorage.getItem("fx_login_companyId");
    }
  },
  methods: {
    //初始化图表
    initChart: function () {
      //处理数据
      let title = [];
      let data = [];
      this.echartData.map((item) => {
        title.push(item.title);
        data.push(item.total);
      });
      //基于准备好的dom，初始化echarts实例
      let echart = echarts.init(document.getElementById("reportChart"));
      this.echartList.push(echart); //加入刷新队列
      //绘制图表
      echart.setOption({
        color: ["#3398DB"],
        title: {
          text: "会员注册统计",
          subtext: "默认显示当月统计数据",
          textStyle: { fontSize: 16, fontWeight: "normal" },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: "5%",
          width: "auto",
          height: "auto",
          containLabel: true,
        },
        xAxis: {
          data: title,
        },
        yAxis: {
          type: "value",
          minInterval: 1,
        },
        series: [
          {
            name: "新增会员",
            type: "line",
            data: data,
          },
        ],
      });
    },
    //初始化数据
    initData: function () {
      let _this = this;
      let sendUrl = "/report/member/register";
      if (_this.dateRange.length > 0) {
        sendUrl += "?startTime=" + _this.dateRange[0];
        sendUrl += "&endTime=" + _this.dateRange[1];
      }
      AxiosAjax({
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.echartData = res.data;
          _this.initChart();
        },
        error: function (err) {
          _this.echartData = [];
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },
  },
  created: function () {
    //初始化数据
    this.initData();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Report/MemberReg.vue